// 📁 src/components/Payment/OrderSummaryPanel.jsx

import React from 'react';
import '../../styles/payment.css';

const OrderSummaryPanel = ({
  selectedModules = [],
  billingCycle = 'monthly',
  currency = 'USD',
  discountRate = 0,
  promoDiscountRate = 0,
  promoName = '',
  promoDurationMonths = 0,
  tenantId = ''
}) => {
  const isAnnual = billingCycle === 'annual';
  const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';

  const moduleRows = selectedModules.map((mod) => ({
    name: mod.name,
    price: mod.price || 0,
    lineTotal: mod.price || 0
  }));

  const finalAmountFromProductCard = moduleRows.reduce((sum, row) => sum + row.lineTotal, 0);

  let originalAmount = finalAmountFromProductCard;
  let annualDiscountAmount = 0;
  let promoDiscountAmount = 0;
  let subtotalAfterDiscounts = finalAmountFromProductCard;

  if (isAnnual) {
    const totalDiscountRate = discountRate + promoDiscountRate;
    originalAmount = finalAmountFromProductCard / (1 - totalDiscountRate / 100);
    annualDiscountAmount = originalAmount * (discountRate / 100);
    promoDiscountAmount = originalAmount * (promoDiscountRate / 100);
    subtotalAfterDiscounts = originalAmount - annualDiscountAmount - promoDiscountAmount;
  } else {
    originalAmount = finalAmountFromProductCard / (1 - promoDiscountRate / 100);
    annualDiscountAmount = 0;
    promoDiscountAmount = originalAmount * (promoDiscountRate / 100);
    subtotalAfterDiscounts = originalAmount - promoDiscountAmount;
  }

  return (
    <div className="order-summary-panel bg-gray-50 border rounded p-4 shadow-sm mb-6">
      <h3 className="text-lg font-semibold text-indigo-700 mb-3">Order Summary</h3>

      <div className="text-sm text-gray-700 space-y-2">
        {isLoggedIn && tenantId && (
          <p>
            <strong>Tenant ID:</strong> {tenantId}
          </p>
        )}
        <p>
          <strong>Billing Cycle:</strong> {billingCycle}
        </p>
        <p>
          <strong>Currency:</strong> {currency}
        </p>

        <hr className="my-3" />

        {moduleRows.map((row, idx) => (
          <div key={idx} className="flex justify-between">
            <span>{row.name}</span>
            <span>
              {Math.round(row.lineTotal)} {currency}
            </span>
          </div>
        ))}

        <hr className="my-3" />

        <div className="flex justify-between font-medium">
          <span>Base Amount (before discount):</span>
          <span>
            {Math.round(originalAmount)} {currency}
          </span>
        </div>

        {isAnnual && (
          <div className="flex justify-between">
            <span>Annual Discount ({discountRate}%):</span>
            <span>
              -{Math.round(annualDiscountAmount)} {currency}
            </span>
          </div>
        )}

        <div className="flex justify-between">
          <span>Promo Discount ({promoDiscountRate}%):</span>
          <span>
            -{Math.round(promoDiscountAmount)} {currency}
          </span>
        </div>

        <hr className="my-3" />

        <div className="flex justify-between text-green-700 text-lg font-bold mt-2">
          <span>Total Amount (excluding VAT & AIT):</span>
          <span>
            {Math.round(subtotalAfterDiscounts)} {currency}
          </span>
        </div>

        <div className="mt-2 space-y-1 text-sm italic">
          <p className="text-yellow-700">
            {promoDiscountRate > 0
              ? `✓ Includes ${promoDiscountRate}% ${promoName} discount for ${promoDurationMonths} months`
              : '✓ No promo discount applied'}
          </p>
          {isAnnual && discountRate > 0 && (
            <p className="text-green-700">✓ Includes {discountRate}% Yearly Discount</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderSummaryPanel;
